<htm-modal
  id="sessionExpirationModal"
  [modalTitle]="modalTitle"
  [bottomAction]="false"
  size="medium">
  <ng-template>
    @if (renewLoader) {
      <loader></loader>
    } @else {
      <div class="text-container">
        @if (timeLeft() > 0) {
          {{ 'session.time_left' | translate }} {{ timeLeft() }} sekundit
        } @else {
          {{ 'session.login' | translate }}
        }
      </div><!--/text-container-->
      @if (timeLeft() > 0) {
        <div class="button-container">
          <button
            htm-button
            theme="plain"
            (click)="logOut(); modalService.close('sessionExpirationModal')"
            (keyup.enter)="logOut(); modalService.close('sessionExpirationModal')">
            {{ 'button.exit' | translate }}
          </button>
          <button
            htm-button
            (click)="renewLogin()"
            (keyup.enter)="renewLogin()">
            {{ 'session.continue' | translate }}
          </button>
        </div><!--/button-container-->
      } @else {
        <div class="button-container">
          <button
            htm-button
            theme="plain"
            (click)="modalService.close('sessionExpirationModal');"
          (keyup.enter)="modalService.close('sessionExpirationModal')">{{ 'button.close' | translate }}</button>
          <button
            htm-button
            (click)="modalService.close('sessionExpirationModal'); auth.triggerLoginModal()"
          (keyup.enter)="modalService.close('sessionExpirationModal'); auth.triggerLoginModal()">{{ 'button.login_again' | translate }}</button>
        </div>
      }
    }
  </ng-template>
</htm-modal>
